import React, { Fragment } from 'react';

import { OrganizationIcon } from 'components';
import { CategorizerItemByOrganizations } from '../../../../types';
import BackLink from '../../BackLink';
import TournamentList from '../TournamentList';

import './tournamentsByOrganization.scss';

interface Props {
    selectedOrganization: CategorizerItemByOrganizations;
    onBackClick: VoidFn;
}

const TournamentsByOrganization: React.FC<Props> = ({
    selectedOrganization,
    onBackClick,
}) => {
    const { name, items, logo } = selectedOrganization;

    return (
        <Fragment>
            <BackLink
                onClick={onBackClick}
                title={
                    <div styleName="title">
                        <OrganizationIcon logo={logo} />
                        {name}
                    </div>
                }
            />

            <TournamentList
                items={items}
                withSportSummary={false}
                isOrganization={true}
            />
        </Fragment>
    );
};

export default TournamentsByOrganization;
